import React from 'react';
import AnimatedCounter from '../../components/ui/AnimatedCounter';
import FeatureShowcase from '../../components/ui/FeatureShowcase';
import { Receipt, Calculator, FileText, TrendingUp } from 'lucide-react';

const BillingVisual: React.FC = () => (
  <div className="aspect-[4/3] bg-gradient-to-br from-green-50 to-emerald-100 p-4 sm:p-6 lg:p-8 flex items-center justify-center relative overflow-hidden">
    <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-6 w-full max-w-xs sm:max-w-sm relative z-10">
      <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-100">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-accent-green/10 rounded-lg flex items-center justify-center">
            <Receipt className="w-5 h-5 text-accent-green" />
          </div>
          <div>
            <div className="text-sm font-semibold text-gray-900">Invoice #2841</div>
            <div className="text-xs text-gray-400">Auto-generated</div>
          </div>
        </div>
        <span className="px-3 py-1 bg-accent-green/10 text-accent-green text-xs font-semibold rounded-full">
          Paid
        </span>
      </div>
      <div className="space-y-3 mb-6">
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Distance (142 km)</span>
          <span className="font-medium text-navy-950">₹8,520</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Waiting time (2.5 hrs)</span>
          <span className="font-medium text-navy-950">₹1,250</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-gray-600">Toll charges</span>
          <span className="font-medium text-navy-950">₹450</span>
        </div>
        <div className="border-t border-gray-100 pt-3">
          <div className="flex justify-between">
            <span className="font-semibold text-navy-950">Total</span>
            <span className="font-bold text-xl text-accent-green">₹10,220</span>
          </div>
        </div>
      </div>
    </div>

    <div className="absolute top-4 right-4 sm:top-6 sm:right-6 lg:top-10 lg:right-10 bg-white/90 backdrop-blur-sm rounded-xl shadow-sm p-3 sm:p-4 animate-bounce z-20" style={{ animationDuration: '3s' }}>
      <div className="flex items-center gap-2">
        <Calculator className="w-4 h-4 text-accent-green" />
        <span className="text-xs text-gray-500">Calculated automatically based on trip data</span>
      </div>
    </div>

    <div className="absolute top-8 right-4 sm:top-12 sm:right-6 lg:top-16 lg:right-10 bg-white rounded-xl shadow-sm p-3 sm:p-4 animate-bounce z-20" style={{ animationDelay: '0.5s' }}>
      <div className="flex items-center gap-2">
        <TrendingUp className="w-4 h-4 sm:w-5 sm:h-5 text-accent-green" />
        <AnimatedCounter value="+15%" />
        <span className="text-xs text-gray-600 ml-2">Revenue increased</span>
      </div>
      <div className="absolute -bottom-2 left-2">
        <FileText className="w-3 h-3 text-primary-600" />
        <AnimatedCounter value="247 invoices sent today" />
      </div>
    </div>
  </div>
);

const FeatureBilling: React.FC = () => {
  return (
    <FeatureShowcase
      id="billing"
      eyebrow="Automated Billing"
      title="Billing that runs itself"
      highlight=""
      description="Set up pricing rules once by vehicle type, distance, and overtime rates. GaadiMatic calculates costs automatically and generates invoices instantly—no more manual spreadsheets."
      capabilities={[
        "Dynamic pricing by vehicle & distance",
        "Automatic invoice generation",
        "Payment tracking & reminders",
        "Trip P&L reports"
      ]}
      visual={<BillingVisual />}
      stats={[
        { value: "95", label: "Time Saved" },
        { value: "24h", label: "Faster Payments" },
        { value: "247 invoices sent today", label: "Invoices Today" }
      ]}
      ctaText="Explore Automated Billing"
    />
  );
};

export default FeatureBilling;
